import { render } from "./PublicWelfare.vue?vue&type=template&id=f8393398&scoped=true&ts=true"
import script from "./PublicWelfare.vue?vue&type=script&lang=ts"
export * from "./PublicWelfare.vue?vue&type=script&lang=ts"

import "./PublicWelfare.vue?vue&type=style&index=0&id=f8393398&scoped=true&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8393398"]])

export default __exports__